import 'promise-polyfill/src/polyfill'; // load promise polyfill
import 'whatwg-fetch'; // load fetch polyfill
import './polyfills/required';
import lazyload from './lazyload.js';
import initSimpleGallery from './modal-gallery';
import civicCookie from './civic-cookie-config';
import addGoogleDirections from './directions';
import ucasCalculatorInitialise from './ucas-tariff-calculator';
import videoAutoplay from './video-autoplay';
import {tns} from 'tiny-slider/src/tiny-slider';
import personalisation from './personalisation';


lazyload();
civicCookie();
addGoogleDirections();
videoAutoplay();

ucasCalculatorInitialise('.tariff-calculator');


// personalisation
document.personalisation = personalisation;

const pels = document.querySelectorAll('.nav-link-personal');
if (pels.length > 0) {
  document.personalisation.populateBlock();
};


(function() {
  const modalGalleries = document.querySelectorAll('.gallery-to-modal');

  if (modalGalleries.length > 0) {
    initSimpleGallery('.gallery-to-modal', 'data-src-lg');
  }
})();

(function() {
  const modalGalleries = document.querySelectorAll('.flex-gallery');

  if (modalGalleries.length > 0) {
    initSimpleGallery('.flex-gallery', 'data-img-src');
  }
})();

(function() {
  const selector = '.gallery-modal';
  const modalGalleries = document.querySelectorAll(selector);

  if (modalGalleries.length > 0) {
    initSimpleGallery(selector, 'data-img-src');
  }
})();

(function() {
  const clickTriggers = document.querySelectorAll('[data-click-target]');

  clickTriggers.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const selector = item.getAttribute('data-click-target');
      const el = item.querySelector(selector);
      el.click();
    });
  });
})();

(function() {
  const str2 = '[data-youtube-id]';
  const ytEls2 = document.querySelectorAll(str2);
  if (ytEls2.length > 0) {
    import(/* webpackChunkName: "youtube-player" */ './youtubePlayer')
        .then(({default: setup}) => {
          setup(str2);
        });
  };
})();

(function() {
  const searchTriggers = document.querySelectorAll(
      '.sitewide-search-form-search-trigger');
  searchTriggers.forEach((el) => {
    el.addEventListener('click', function(event) {
      const form = el.closest('form');
      form.submit();
    });
  });
})();

(function() {
  const els = document.querySelectorAll('.navigation-overlay-trigger');
  const overlay = document.getElementById('navigation-overlay');

  if (typeof els !== undefined) {
    els.forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        overlay.classList.toggle('navigation-overlay-open');
        if (overlay.classList.contains('navigation-overlay-open')) {
          overlay.focus();
        }
      });
    });
  }

  document.addEventListener('keydown', (event) => {
    if (overlay.classList.contains(
        'navigation-overlay-open') && event.key === 'Escape') {
      overlay.classList.remove('navigation-overlay-open');
    }
  });
})();

(function() {
  const triggerElements = document.querySelectorAll('.toggle-trigger');

  let toggleClass = 'd-none';

  if (typeof triggerElements !== undefined) {
    triggerElements.forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();

        let targetId = null;

        if (el.hasAttribute('href') && el.getAttribute('href')[0] === '#') {
          targetId = el.getAttribute('href');
          targetId = targetId.substring(1);
        } else if (el.hasAttribute('data-target')) {
          targetId = el.getAttribute('data-target');
        }

        if (targetId) {
          if (el.hasAttribute('data-toggle-class')) {
            toggleClass = el.getAttribute('data-toggle-class');
          }

          document.getElementById(targetId).classList.toggle(toggleClass);
        }
      });
    });
  }
})();

(function() {
  const el = document.querySelector('.location-slider');

  if (el) {
    tns(
        {
          'container': '.location-slider',
          'items': 1,
          'controls': true,
          'arrowKeys': true,
          'prevButton': '.location-slider-prev-button',
          'nextButton': '.location-slider-next-button',
          'responsive': {
            '576': {
              'items': 2,
              'controls': true,
            },
            '1200': {
              'items': 3,
              'controls': true,
            },
          },
        },
    );
  }
})();
